// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"0da1c24c","197":"2d31eba3","223":"da8644c5","276":"8081cda1","296":"2520ebba"}[chunkId] + ".chunk.js";
};